import React, { useState } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { Image } from 'react-bootstrap';
import { add3Dots, getRoleClassName } from '../utils/Util';
import { LastLocationType } from '../utils/Types';

export interface IProfileMarkerProps {
  onUserMarkerClick?: (lastLocation: LastLocationType) => void;
  lastLocation: LastLocationType;
  photo: string;
  name: string;
  roleName: string;
  enableHover?: boolean;
  markerColour?: boolean;
}
const ProfileMarker = ({
  onUserMarkerClick,
  lastLocation,
  photo,
  name,
  roleName,
  enableHover = true,
  markerColour = false,
}: IProfileMarkerProps) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <AdvancedMarker
      onClick={() => {
        if (onUserMarkerClick) onUserMarkerClick(lastLocation);
      }}
      position={{
        lat: Number(lastLocation.latitude),
        lng: Number(lastLocation.longitude),
      }}
    >
      <div
        key={lastLocation?.status}
        className={
          enableHover
            ? `marker-bg ${lastLocation?.status === 'Logged' && lastLocation?.markerColour == '#56B38F' ? 'bg-true' : 'bg-false'}`
            : `marker-bg ${markerColour ? 'bg-true' : 'bg-false'}`
        }
        onMouseEnter={() => enableHover && setIsHovered(true)}
        onMouseLeave={() => enableHover && setIsHovered(false)}
      >
        <Image roundedCircle src={photo} className="marker-image" />
        <div className={`role-bg ${getRoleClassName(roleName)}`}>
          {add3Dots(name, 30)}
        </div>

        {isHovered && enableHover && (
          <div
            style={{
              position: 'absolute',
              top: '-30px',
              left: '0',
              backgroundColor: '#333',
              color: '#fff',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              zIndex: 1000,
            }}
          >
            <div>Name: {lastLocation.employeename}</div>
            <div>Role: {lastLocation.rolename}</div>
            <div>Mobile No: {lastLocation.mobilenumber}</div>
            <div>Emp ID: {lastLocation.employeeuniqueid}</div>
            <div>Location: {lastLocation.locationname}</div>
          </div>
        )}
      </div>
    </AdvancedMarker>
  );
};

export default ProfileMarker;
